export default class PublicLiveStream {
  activeSubscribers: number;
  totalSubscribers: number;
  maxSubscribers: number;
  id: number;
  roomId: number;
  roomJid: string;
  userId: string;
  ownerXmppId: string;
  owner_userId: number;
  imageUrl: string;
  name: string;
  displayName: string;
  ageTitle: string;
  location: string;
  avatarUrl: string;
  streamId: string;
  status: number;

  constructor(data: any) {
    this.activeSubscribers = data.active_subscribers;
    this.totalSubscribers = data.total_subscribers;
    this.maxSubscribers = data.max_subscribers;
    this.id = data.id || data.roomId;
    this.roomId = data.roomId;
    this.roomJid = data.roomJid;
    this.userId = data.userId;
    this.ownerXmppId = data.owner_userId;
    this.owner_userId = Number(data.owner_userId);
    this.imageUrl = data.imageUrl;
    this.name = data.name;
    this.displayName = data.displayName;
    this.ageTitle = data.ageTitle;
    this.location = data.location;
    this.avatarUrl = data.avatarUrl;
    this.streamId = data.name;
    this.status = data.status;
  }
}

export interface PublicLiveStreamItem extends PublicLiveStream {
  isWatching: boolean;
  isJoiningStream: boolean;
  isHidden: boolean;
}
